// GAVION product-training: the « Produit » course texts. Questions transcribed from
// docs/superpowers/specs/2026-11-02-product-training-questions.md (approved by the owner 2026-11-02); every fact comes
// from the Contexte Gavion (Formation → « Tout sur Gavion »). Option « a » is always the right answer; the display
// order is set in training/content/product/staticQuestions.ts.
export const productMissionsFr = {
  product_pitch: {
    title: "Gala en 30 secondes",
    desc: "%{count} questions pour présenter Gala et Gavion.",
  },
  product_pricing: {
    title: "Forfaits et prix",
    desc: "%{count} questions sur les forfaits, avec les prix du catalogue.",
  },
  product_addons: {
    title: "Options et conditions",
    desc: "%{count} questions sur les options et les conditions.",
  },
  product_fit: {
    title: "Le bon forfait",
    desc: "%{count} situations : quel forfait proposer?",
  },
  product_objections: {
    title: "Objections",
    desc: "%{count} objections et la bonne réponse.",
  },
  product_availability: {
    title: "Disponible ou « Bientôt »",
    desc: "%{count} fonctions : en ligne aujourd'hui, ou à venir?",
  },
  product_how_gala: {
    title: "Comment Gala répond",
    desc: "%{count} questions sur un appel avec Gala.",
  },
  product_setup: {
    title: "La configuration",
    desc: "%{count} questions sur la mise en place.",
  },
  product_integrations: {
    title: "Les intégrations",
    desc: "%{count} questions sur les outils branchés.",
  },
  product_client_gets: {
    title: "Ce que le client reçoit",
    desc: "%{count} questions sur ce que le client voit et reçoit.",
  },
  product_admin_assistant: {
    title: "Adjointe administrative",
    desc: "%{count} questions sur l'adjointe administrative.",
  },
};

export const trainingProductFr = {
  course: {
    label: "Parcours",
    phone: "Vente au téléphone",
    product: "Produit",
  },
  tracks: {
    sell: {
      title: "Vendre Gavion",
      subtitle: "Ce qu'un vendeur doit savoir pour présenter et vendre Gala.",
    },
    deep: {
      title: "Gavion à fond",
      subtitle:
        "Le produit en détail : l'appel, la mise en place, les intégrations, l'adjointe.",
      locked_hint: "Réussis tout « Vendre Gavion » pour débloquer ce parcours.",
    },
  },
  catalog_unavailable: "Catalogue indisponible : réessaie plus tard.",
  read_context: "Lire dans Tout sur Gavion",
  availability: {
    available: "Disponible",
    soon: "Bientôt",
    explanation:
      "Ne jamais présenter une fonction « Bientôt » comme disponible. Formulation sûre : « QuickBooks, Stripe et la répartition des équipes arrivent bientôt. »",
  },
  q: {
    product_pitch: {
      q1: {
        prompt: "Qu'est-ce que Gala?",
        a: "Une réceptionniste IA bilingue et une assistante administrative pour les entreprises de services et de construction",
        b: "Un centre d'appels avec des réceptionnistes humaines",
        c: "Un logiciel de comptabilité pour entrepreneurs",
        d: "Un menu téléphonique « faites le 1 »",
        explanation:
          "Gala répond à chaque appel, 24/7, en français québécois et en anglais.",
      },
      q2: {
        prompt: "Pour quelle clientèle Gala est-elle conçue?",
        a: "Les PME de services et de construction du Québec (plomberie, CVAC, électricité, toiture, déneigement…)",
        b: "Les grandes banques",
        c: "Les cliniques médicales",
        d: "Les boutiques en ligne",
        explanation:
          "Le site ne présente pas Gala comme adaptée au secteur de la santé.",
      },
      q3: {
        prompt: "Quel problème Gala règle-t-elle d'abord?",
        a: "Les appels manqués : un appel manqué, c'est un client qui appelle la prochaine compagnie",
        b: "Les factures impayées",
        c: "Le recrutement d'employés",
        d: "La gestion de l'inventaire",
        explanation:
          "« Un appel manqué, c'est un client qui appelle la prochaine compagnie sur sa liste. »",
      },
      q4: {
        prompt: "Quels sont les deux rôles de Gala?",
        a: "Réceptionniste (pendant l'appel) et assistante administrative (le travail de bureau après l'appel)",
        b: "Réceptionniste et comptable",
        c: "Vendeuse et répartitrice",
        d: "Réceptionniste et technicienne",
        explanation:
          "L'assistante administrative inclut la réceptionniste complète.",
      },
      q5: {
        prompt: "Dans quelles langues Gala répond-elle au téléphone?",
        a: "En français québécois et en anglais, détectés automatiquement, sur le même numéro (44 langues prises en charge)",
        b: "En français seulement",
        c: "En anglais, le français coûte un supplément",
        d: "Deux numéros, un par langue",
        explanation: "« Un seul numéro, deux langues, aucun supplément. »",
      },
      q6: {
        prompt:
          "Un prospect dit : « Donc ça remplace ma réceptionniste? » Que répond-on?",
        a: "Non : Gala prend ce que personne ne fait (appels du soir, relances, soumissions qui attendent)",
        b: "Oui, vous économisez son salaire",
        c: "Oui, après un mois d'essai",
        d: "Ça dépend du forfait",
        explanation:
          "Le remplacement du personnel « n'est pas l'argument que nous faisons ».",
      },
      q7: {
        prompt: "Où sont hébergées les données?",
        a: "Au Canada; le serveur applicatif est au Québec, à Beauharnois",
        b: "Aux États-Unis",
        c: "En Europe",
        d: "Sur l'ordinateur du client",
        explanation:
          "Données jamais vendues, jamais utilisées pour entraîner des modèles tiers.",
      },
      q8: {
        prompt: "Qui a fondé Gavion, et où?",
        a: "Antoine, Vincent et Martin Gagnon, à Montréal, en 2026",
        b: "Une firme américaine de Silicon Valley",
        c: "Un groupe de Toronto en 2015",
        d: "Une franchise française",
        explanation: "Gavion inc. est une entreprise montréalaise d'IA vocale.",
      },
    },
    product_addons: {
      c1: {
        prompt: "Combien coûte l'installation?",
        a: "0 $, sur tous les forfaits",
        b: "199 $",
        c: "499 $",
        d: "Un mois de forfait",
        explanation:
          "L'accompagnement à la mise en route est offert en option, à la carte.",
      },
      c2: {
        prompt: "Quel rabais donne la facturation annuelle?",
        a: "15 %, payée en un seul versement au début de la période",
        b: "10 %",
        c: "2 mois gratuits",
        d: "Aucun rabais",
        explanation: "",
      },
      c3: {
        prompt: "Un client veut annuler. Qu'est-ce qui s'applique?",
        a: "Annulable en tout temps, aucuns frais; le forfait reste actif jusqu'à la fin de la période payée",
        b: "Pénalité de 3 mois",
        c: "Contrat d'un an minimum",
        d: "Remboursement au prorata",
        explanation:
          "Ne jamais promettre ni évoquer un remboursement, même pour un forfait annuel.",
      },
      c4: {
        prompt: "Qu'est-ce qu'un « usager »?",
        a: "Une personne avec un accès nommé à la plateforme (les clients qui appellent n'en sont pas)",
        b: "Chaque client qui appelle",
        c: "Chaque numéro de téléphone",
        d: "Chaque technicien sur la route",
        explanation:
          "Un agent vocal, lui, est une personnalité téléphonique distincte, avec son numéro et son script.",
      },
      c5: {
        prompt: "Le client dépasse ses minutes. Que se passe-t-il?",
        a: "Les minutes en plus sont facturées au tarif publié du forfait (0,33 $ à 0,42 $), à la minute supérieure",
        b: "Gala arrête de répondre",
        c: "Il doit changer de forfait tout de suite",
        d: "C'est gratuit",
        explanation:
          "Plus de 1 000 minutes par mois : configuration adaptée sur demande.",
      },
      c6: {
        prompt: "Le client peut-il essayer avant d'acheter?",
        a: "Il peut appeler la ligne de démonstration ou demander que Gala le rappelle; il n'y a ni essai gratuit ni garantie de remboursement",
        b: "Oui, 30 jours d'essai gratuit",
        c: "Oui, satisfait ou remboursé",
        d: "Non, aucune démonstration",
        explanation: "Ligne où Gala répond en direct : +1 (514) 534-1298.",
      },
    },
    product_fit: {
      q1: {
        prompt:
          "Un plombier travaille seul et manque des appels quand il est sur un chantier.",
        a: "Réceptionniste — Essentielle",
        b: "Adjointe — Entreprise",
        c: "Réceptionniste — Entreprise",
        d: "Adjointe — Avancé",
        explanation:
          "« Pour les travailleurs autonomes et les petites équipes. » 250 minutes, 3 usagers.",
      },
      q2: {
        prompt:
          "Une entreprise de toiture de 5 personnes, volume d'appels régulier, veut seulement qu'on réponde.",
        a: "Réceptionniste — Avancé",
        b: "Réceptionniste — Essentielle",
        c: "Adjointe — Essentielle",
        d: "Adjointe — Entreprise",
        explanation:
          "« Pour les équipes en croissance au volume d'appels régulier. » 500 minutes, 5 usagers.",
      },
      q3: {
        prompt:
          "Un paysagiste veut aussi envoyer des devis par photo à ses clients.",
        a: "Une formule Adjointe administrative",
        b: "Réceptionniste — Entreprise",
        c: "Réceptionniste — Essentielle",
        d: "Aucun forfait ne le fait",
        explanation:
          "Le devis par photo est une fonction de l'assistante administrative.",
      },
      q4: {
        prompt:
          "Une entreprise CVAC avec plusieurs équipes et plus de 900 minutes d'appels par mois.",
        a: "Réceptionniste — Entreprise (1 000 minutes, 7 usagers)",
        b: "Réceptionniste — Essentielle",
        c: "Réceptionniste — Avancé",
        d: "Adjointe — Essentielle",
        explanation: "« Pour les opérations occupées à plusieurs équipes. »",
      },
      q5: {
        prompt:
          "Un client a deux bannières, chacune avec son numéro et son accueil.",
        a: "Il lui faut deux agents vocaux (inclus selon le forfait, ou 10 $/mois de plus)",
        b: "Deux abonnements complets",
        c: "Impossible avec Gala",
        d: "Un usager de plus",
        explanation: "Essentielle : 1 agent vocal, Avancé : 2, Entreprise : 3.",
      },
      q6: {
        prompt:
          "Un client demande si les urgences 24/7 sont dans le forfait d'entrée.",
        a: "Oui : tous les forfaits Réceptionniste ont les mêmes fonctions, urgences et transferts compris",
        b: "Seulement dans Entreprise",
        c: "Seulement dans Avancé et Entreprise",
        d: "C'est une option payante",
        explanation:
          "Les forfaits diffèrent par les minutes, les usagers et les agents vocaux.",
      },
    },
    product_objections: {
      q1: {
        prompt: "« Mes clients n'aiment pas parler à un robot. »",
        a: "Voix naturelle, en temps réel, sans menu à touches; l'alternative actuelle, c'est souvent la boîte vocale",
        b: "« Gala ne dira jamais qu'elle est une IA »",
        c: "« Vous pouvez désactiver l'IA »",
        d: "« C'est une humaine en réalité »",
        explanation:
          "Ne jamais dire que Gala cache être une IA quand on le lui demande.",
      },
      q2: {
        prompt: "« Et si elle ne sait pas la réponse? »",
        a: "Elle n'invente jamais : elle reformule une fois, puis transfère ou prend un message détaillé avec rappel prioritaire",
        b: "Elle devine la meilleure réponse",
        c: "Elle raccroche",
        d: "Elle met l'appelant en attente",
        explanation: "« Mieux vaut un transfert qu'une réponse inventée. »",
      },
      q3: {
        prompt: "« Elle va donner des prix n'importe comment. »",
        a: "Pas de prix ferme au téléphone : seulement les montants que vous approuvez",
        b: "Elle calcule le prix final elle-même",
        c: "Elle donne le prix le plus bas",
        d: "Elle ne parle jamais d'argent",
        explanation: "Les devis restent dans vos fourchettes approuvées.",
      },
      q4: {
        prompt: "« Je ne suis pas technique. »",
        a: "Rien à installer, aucun matériel; étapes guidées et soutien au besoin",
        b: "Il faut un technicien sur place",
        c: "Il faut acheter un téléphone IP",
        d: "Il faut coder l'agent",
        explanation: "",
      },
      q5: {
        prompt: "« Je dois changer de numéro? »",
        a: "Non, un simple renvoi d'appel; les clients appellent le même numéro",
        b: "Oui, Gala fournit un nouveau numéro",
        c: "Oui, pour la deuxième langue",
        d: "Seulement pour le forfait d'entrée",
        explanation: "",
      },
      q6: {
        prompt: "« Je suis trop petit pour ça. »",
        a: "C'est là que l'écart est le plus grand : un seul contrat de plus de 129 $ récupéré paie le mois",
        b: "« Revenez quand vous aurez une équipe »",
        c: "« Prenez le forfait Entreprise »",
        d: "« On garantit 2 800 $ par mois »",
        explanation:
          "Ne jamais garantir un résultat chiffré : le calculateur donne une estimation.",
      },
      q7: {
        prompt: "« Ça prend combien de temps à mettre en place? »",
        a: "En seulement quelques jours",
        b: "24 heures garanties",
        c: "Six semaines",
        d: "Ça dépend du technicien",
        explanation: "C'est la seule formulation permise : aucun autre délai.",
      },
      q8: {
        prompt: "« ChatGPT peut faire ça. »",
        a: "Un assistant conversationnel ne répond pas au téléphone à 19 h, ne connaît pas vos prix et n'accède pas à votre agenda",
        b: "« ChatGPT est moins bon que nous »",
        c: "« Gala, c'est ChatGPT »",
        d: "« Vous avez raison, utilisez ChatGPT »",
        explanation: "Rester factuel, ne jamais dénigrer.",
      },
    },
    product_how_gala: {
      q1: {
        prompt:
          "Que fait Gala quand plusieurs clients appellent en même temps?",
        a: "Elle répond à tous : aucune ligne occupée, aucune mise en attente",
        b: "Elle met les autres en attente",
        c: "Le deuxième tombe sur la boîte vocale",
        d: "Elle rappelle plus tard",
        explanation: "",
      },
      q2: {
        prompt: "Un client appelle pour une urgence (tuyau éclaté à 2 h).",
        a: "Elle pose les questions d'urgence, transfère à la ligne de garde avec texto à l'équipe; si personne ne répond, message détaillé et rappel prioritaire",
        b: "Elle prend un rendez-vous dans 3 jours",
        c: "Elle dit de rappeler demain",
        d: "Elle donne un prix ferme",
        explanation: "",
      },
      q3: {
        prompt: "Comment Gala qualifie-t-elle un prospect?",
        a: "Avec vos propres questions de qualification, et elle trie les urgences selon vos règles",
        b: "Avec un questionnaire fixe de Gavion",
        c: "Elle ne qualifie pas",
        d: "Elle demande la carte de crédit",
        explanation: "",
      },
      q4: {
        prompt: "Un client récurrent appelle.",
        a: "Gala le reconnaît à partir de votre CRM; un résumé écrit de l'appel va au tableau de bord",
        b: "Elle lui redemande tout",
        c: "Elle le transfère toujours",
        d: "Elle ne garde aucune trace",
        explanation: "",
      },
      q5: {
        prompt: "Que ne fait jamais Gala au téléphone?",
        a: "Donner un prix ferme, promettre une disponibilité non vérifiée ou dire ce qui n'est pas dans la base de connaissances",
        b: "Prendre un rendez-vous",
        c: "Transférer un appel",
        d: "Envoyer un texto de confirmation",
        explanation: "Ce sont les garde-fous.",
      },
      q6: {
        prompt: "Gala répond-elle aussi aux textos et aux courriels?",
        a: "Oui, 24/7, par appel, texto et courriel",
        b: "Seulement aux appels",
        c: "Seulement aux courriels",
        d: "Seulement aux heures d'ouverture",
        explanation: "",
      },
    },
    product_setup: {
      q1: {
        prompt: "Quelle est la première étape de la mise en place?",
        a: "Créer la réceptionniste (une première « mini Gala »)",
        b: "Acheter du matériel",
        c: "Changer de numéro",
        d: "Signer un contrat d'un an",
        explanation:
          "Puis : montrer l'entreprise, brancher le téléphone, tester, enrichir.",
      },
      q2: {
        prompt: "Que faut-il apprendre à Gala sur l'entreprise?",
        a: "Services, prix, territoires, règles d'urgence et ce qu'elle a le droit de dire",
        b: "Rien, elle devine",
        c: "Seulement l'adresse",
        d: "Les mots de passe des employés",
        explanation: "On branche aussi l'agenda et la liste de clients.",
      },
      q3: {
        prompt: "Qu'est-ce qui fixe le rythme de la mise en place?",
        a: "La taille de l'entreprise : nombre de services, d'employés et de règles",
        b: "Le forfait choisi",
        c: "La météo",
        d: "Le nombre d'appels",
        explanation:
          "Désignez la personne qui remplit et valide la base de connaissances.",
      },
      q4: {
        prompt: "Gala dépend-elle d'Internet au bureau?",
        a: "Non, elle est hébergée : rien ne dépend de la connexion du bureau",
        b: "Oui, il faut la fibre",
        c: "Oui, un serveur sur place",
        d: "Seulement pour les textos",
        explanation: "",
      },
      q5: {
        prompt: "Que recommande-t-on après le lancement?",
        a: "Écouter les appels du premier mois, puis une revue de 30 minutes chaque trimestre",
        b: "Rien",
        c: "Tout reconfigurer chaque semaine",
        d: "Changer de forfait chaque mois",
        explanation: "",
      },
      q6: {
        prompt: "Quel soutien le client a-t-il?",
        a: "Une équipe bilingue établie au Québec, soutien 24/7",
        b: "Un forum en anglais",
        c: "Courriel seulement, 5 jours ouvrables",
        d: "Aucun soutien",
        explanation: "",
      },
    },
    product_integrations: {
      q1: {
        prompt: "Quels agendas Gala utilise-t-elle aujourd'hui?",
        a: "Google Agenda et Outlook (Microsoft 365)",
        b: "Seulement Google",
        c: "Seulement un agenda Gavion",
        d: "Aucun",
        explanation: "",
      },
      q2: {
        prompt: "Comment brancher le numéro d'affaires actuel?",
        a: "Par renvoi d'appel, aucun matériel",
        b: "En le transférant chez Gavion",
        c: "Avec un boîtier",
        d: "Impossible",
        explanation: "",
      },
      q3: {
        prompt: "Le client utilise un outil qui n'est pas dans la liste.",
        a: "On peut généralement le connecter par API ou webhook; on confirme avant la signature",
        b: "C'est impossible",
        c: "On promet que ça marche",
        d: "On lui dit de changer d'outil",
        explanation: "« Nommez vos outils avant de signer. »",
      },
      q4: {
        prompt: "QuickBooks est-il branché aujourd'hui?",
        a: "Non, il arrive bientôt",
        b: "Oui, sur tous les forfaits",
        c: "Oui, sur Entreprise",
        d: "Oui, en option",
        explanation: "",
      },
      q5: {
        prompt: "Comment la liste de clients arrive-t-elle dans Gala?",
        a: "Par le CRM du client, ou on l'importe",
        b: "Il faut la retaper",
        c: "Gala la trouve sur Google",
        d: "Elle n'en a pas besoin",
        explanation: "",
      },
      q6: {
        prompt:
          "Un client déjà sur Jobber cherche surtout une intégration native.",
        a: "On reste honnête : le site lui-même dit qu'un concurrent comme Fulltime.ai peut mieux convenir",
        b: "On dit que Gala s'intègre déjà à Jobber",
        c: "On dénigre Jobber",
        d: "On cite les prix du concurrent",
        explanation:
          "Rester factuel, ne jamais citer les prix des concurrents.",
      },
    },
    product_client_gets: {
      q1: {
        prompt: "Après chaque appel, le client trouve…",
        a: "Un résumé écrit dans le tableau de bord",
        b: "Rien",
        c: "Seulement l'enregistrement audio",
        d: "Une facture",
        explanation: "",
      },
      q2: {
        prompt: "Que montre le tableau de bord?",
        a: "Appels, transcriptions, réservations, usage et analytique, sur ordinateur ou téléphone",
        b: "Seulement les factures",
        c: "Seulement les minutes",
        d: "Rien, tout est par courriel",
        explanation: "",
      },
      q3: {
        prompt: "Comment l'équipe sait-elle qu'il y a une urgence?",
        a: "L'appel est transféré à la ligne de garde, avec un texto à l'équipe",
        b: "Par la poste",
        c: "Le lendemain matin",
        d: "Elle ne le sait pas",
        explanation: "",
      },
      q4: {
        prompt: "Que reçoit le client final après une prise de rendez-vous?",
        a: "Confirmations et rappels par texto et courriel",
        b: "Rien",
        c: "Un appel d'un humain",
        d: "Une facture",
        explanation: "",
      },
      q5: {
        prompt: "Les enregistrements d'appels, s'ils sont activés…",
        a: "Sont stockés au Canada et supprimés après 90 jours",
        b: "Sont gardés pour toujours",
        c: "Sont vendus",
        d: "Sont aux États-Unis",
        explanation:
          "L'audio en direct est en rétention zéro chez le fournisseur vocal.",
      },
      q6: {
        prompt: "Que reçoit le client au sujet des appels bloqués?",
        a: "Un sommaire quotidien des pourriels, sollicitations et robots bloqués",
        b: "Rien",
        c: "Un appel de chaque robot",
        d: "Une facture par appel bloqué",
        explanation: "",
      },
    },
    product_admin_assistant: {
      q1: {
        prompt: "L'adjointe administrative inclut-elle la réceptionniste?",
        a: "Oui, la réceptionniste complète",
        b: "Non, il faut les deux abonnements",
        c: "Seulement les appels du jour",
        d: "Seulement les courriels",
        explanation: "",
      },
      q2: {
        prompt: "Comment fonctionne le devis par photo?",
        a: "Le client envoie une photo ou une adresse; vision IA et mesure satellite donnent un devis préliminaire en quelques minutes, dans vos fourchettes",
        b: "Un technicien se déplace toujours",
        c: "Gala donne un prix ferme",
        d: "Le client remplit un formulaire papier",
        explanation:
          "Le prix ferme reste confirmé par votre équipe; une photo insuffisante est signalée pour visite.",
      },
      q3: {
        prompt: "Combien de devis sont inclus?",
        a: "5 / mois (Essentielle), 15 / mois (Avancé), illimités (Entreprise)",
        b: "Aucun",
        c: "1 par mois partout",
        d: "Illimités partout",
        explanation: "Devis additionnel dès 8 $.",
      },
      q4: {
        prompt: "Que fait le CRM 360° de l'adjointe?",
        a: "Chaque appel, message, intervention et paiement enrichit la fiche client",
        b: "Il remplace la comptabilité",
        c: "Il envoie des infolettres",
        d: "Il gère la paie",
        explanation: "",
      },
      q5: {
        prompt: "Quels documents l'adjointe produit-elle?",
        a: "Contrats, bons de travail, rapports photo avant-après, certificats de fin de chantier",
        b: "Déclarations d'impôt",
        c: "Talons de paie",
        d: "Permis de construction",
        explanation:
          "Plus un registre des consentements, un journal d'audit, l'export et le droit à l'effacement.",
      },
      q6: {
        prompt: "Quelle analytique l'adjointe donne-t-elle?",
        a: "Chiffre d'affaires par technicien, conversion par source, facture moyenne par service, prédictions saisonnières",
        b: "Aucune",
        c: "Seulement le nombre d'appels",
        d: "La météo",
        explanation: "",
      },
    },
    product_availability: {
      q1: {
        prompt:
          "Prise de rendez-vous dans Google Agenda ou Outlook pendant l'appel",
      },
      q2: { prompt: "Synchro QuickBooks" },
      q3: { prompt: "Acomptes et paiements Stripe" },
      q4: { prompt: "Appels sortants (rappels, relance des soumissions)" },
      q5: { prompt: "Planification et répartition des équipes" },
      q6: {
        prompt:
          "Filtrage des pourriels et robots d'appel, avec sommaire quotidien",
      },
      q7: { prompt: "Devis par photo (assistante administrative)" },
      q8: { prompt: "Plusieurs appels en même temps, sans ligne occupée" },
    },
  },
};
